const toasterInitialState = {
    toaster: {
        show: false,
        data: null
    },
};

export default toasterInitialState;